import {FC} from 'react'
import {MultiTagFilteringFieldRow} from 'components/SearchForm/MultiTagFilteringFieldRow'
import {withNull} from 'libs/options'

const handicapTypes = [
  {id: 'none', name: '対象外'},
  {id: 'normal', name: '一般障害者'},
  {id: 'special', name: '特別障害者'},
]

export const HandicapTypes: FC = () => {
  return (
    <MultiTagFilteringFieldRow
      header="障害者区分"
      name="handicapTypes"
      list={withNull(handicapTypes)}
      shouldUnregister
    />
  )
}
